(function($) {

    const backToTopBtn = document.getElementById('back_to_top');
    const scrollTrigger = 100;

    if (!backToTopBtn) return;

    const toggleBackToTopBtn = () => {
        if (window.scrollY > scrollTrigger) {
            backToTopBtn.classList.add('back_to_top--show');
        } else {
            backToTopBtn.classList.remove('back_to_top--show');
        }
    };

    window.addEventListener('scroll', toggleBackToTopBtn);

    backToTopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggleBackToTopBtn();




})(jQuery);